import Vue from 'vue';
import Vuex from 'vuex';
// 学生端不需要续课功能，已注释 get_server_time
// import {  get_server_time } from '@/api/home'
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    loginData: JSON.parse(localStorage.getItem('zhimingLoginData')) || null,
    userTokenData: JSON.parse(localStorage.getItem('zhimingUserTokenData')) || null,
    loginType: JSON.parse(localStorage.getItem('zhimingLoginType')) || null,
    menuId: JSON.parse(localStorage.getItem('zhimingMenuId')) || null,
    classId: JSON.parse(localStorage.getItem('zhimingClassId')) || null,
    subjectId: JSON.parse(localStorage.getItem('zhimingSubjectId')) || null,
    subjectName: localStorage.getItem('zhimingSubjectName') || null,
    versionId: JSON.parse(localStorage.getItem('zhimingVersionId')) || null,
    semesterId: JSON.parse(localStorage.getItem('zhimingSemesterId')) || null,
    semesterName: localStorage.getItem('zhimingSemesterName') || null,
    chapterId: JSON.parse(localStorage.getItem('zhimingChapterId')) || null,
    planData: JSON.parse(localStorage.getItem('zhimingPlanData')) || null,
    chapterName: JSON.parse(localStorage.getItem('zhimingChapterName')) || null,  //这个是点击计划才会保存的章节名称
    topicData: JSON.parse(localStorage.getItem('zhimingTopicData')) || null,
    setId: JSON.parse(localStorage.getItem('zhimingSetId')) || null,
    studentInfo: JSON.parse(localStorage.getItem('zhimingStudentInfo')) || null,
    isFirstTitleExists: localStorage.getItem('zhimingIsFirstTitleExists'), //组合作文是否有标题 有第一个答题区域居中
    pictureSize: null,
    originScale: sessionStorage.getItem('OriginScale') || 1, //讲解 缩放大小
    // shouldCache: JSON.parse(sessionStorage.getItem('ShouldCache')) || [], // 初始需要缓存的页面
    activeStudent: JSON.parse(sessionStorage.getItem('zhimingActiveStudent')) || [],
    activeGroup: [],
    activeNumber: 2,
    groupNumber: 2,
    textKey:0,
    manualCorrectionBtnShow: JSON.parse(localStorage.getItem('zhimingManualCorrectionBtnShow')) || false,
    reportRank: JSON.parse(localStorage.getItem('zhimingReportRank')) || 25,
    correctStudentList: sessionStorage.getItem('CorrectStudentList') ? JSON.parse(sessionStorage.getItem('CorrectStudentList')) : [], //批改了的学生数据
    isFullScreen: JSON.parse(sessionStorage.getItem('IsFullScreen')) || false,
    question_correct: sessionStorage.getItem('CorrectQuestionList') ? sessionStorage.getItem('CorrectQuestionList') : [], //批改了的题目数据
    // 2026-08-24: coursewareList/coursewarevideoList已随悬浮课件/视频历史功能一并移除
    // 学生端不需要续课功能，已注释 dialogVisibleTime
    // dialogVisibleTime: false,
    openChongPi: false,
    note: false,
    reset: false,

  },
  mutations: {
    // 学生端不需要续课功能，已注释 setDialogVisibleTime
    // setDialogVisibleTime(state, value) {
    //   state.dialogVisibleTime = value;
    // },
    getopenChongPi(state,value) {
      state.openChongPi=value
    },
    getnote(state,value) {
      state.note =value
    },
    setReset(state, value) {
      state.reset = value
    },
    gettextKey(state,value) {
      state.textKey =value
    },
    //登录信息
    getLoginData(state, n) {
      state.loginData = n;
      localStorage.setItem('zhimingLoginData', JSON.stringify(n))
    },
    //token
    getUserTokenData(state, n) {
      state.userTokenData = n;
      localStorage.setItem('zhimingUserTokenData', JSON.stringify(n))
    },
    //登陆类型
    getLoginType(state, n) {
      state.loginType = n;
      localStorage.setItem('zhimingLoginType', JSON.stringify(n))
    },
    //学科Id
    getSubjectId(state, n) {
      state.subjectId = n;
      localStorage.setItem('zhimingSubjectId', JSON.stringify(n))
    },
    //学科名称
    getSubjectName(state, n) {
      state.subjectName = n;
      localStorage.setItem('zhimingSubjectName', n)
    },
    //读写选择Id
    getMenuId(state, n) {
      state.menuId = n;
      localStorage.setItem('zhimingMenuId', JSON.stringify(n))
    },
    //班级选择Id
    getClassId(state, n) {
      state.classId = n;
      localStorage.setItem('zhimingClassId', JSON.stringify(n))
    },
    //教材版本选择Id
    getVersionId(state, n) {
      state.versionId = n;
      localStorage.setItem('zhimingVersionId', JSON.stringify(n))
    },
    //学期选择Id
    getSemesterId(state, n) {
      state.semesterId = n;
      localStorage.setItem('zhimingSemesterId', JSON.stringify(n))
    },
    //学期选择名称
    getSemesterName(state, n) {
      state.semesterName = n;
      localStorage.setItem('zhimingSemesterName', n)
    },
    //章节选择Id
    getChapterId(state, n) {
      state.chapterId = n;
      localStorage.setItem('zhimingChapterId', JSON.stringify(n))
    },
    //计划信息
    getPlanData(state, n) {
      state.planData = n;
      localStorage.setItem('zhimingPlanData', JSON.stringify(n))
    },
    //章节名称
    getChapterName(state, n) {
      state.chapterName = n;
      localStorage.setItem('zhimingChapterName', JSON.stringify(n))
    },
    //题目信息
    getTopicData(state, n) {
      state.topicData = n;
      localStorage.setItem('zhimingTopicData', JSON.stringify(n))
    },
    //setId
    getSetId(state, n) {
      state.setId = n;
      localStorage.setItem('zhimingSetId', JSON.stringify(n))
    },
    //点击的学生信息
    getStudentInfo(state, n) {
      state.studentInfo = n;
      localStorage.setItem('zhimingStudentInfo', JSON.stringify(n))
    },
    //组合作文是否有标题
    getIsFirstTitleExists(state, n) {
      state.isFirstTitleExists = n;
      localStorage.setItem('zhimingIsFirstTitleExists', n)
    },
    //纸张尺寸
    getPictureSize(state, n) {
      state.pictureSize = n;
    },
    //canvas 放大缩小
    getOriginScale(state, n) {
      state.originScale = n;
      sessionStorage.setItem('OriginScale', state.originScale);
    },
    //也mains是否缓存
    // getUpdateCache(state, n) {
    //   state.shouldCache = n;
    //   sessionStorage.setItem('ShouldCache', JSON.stringify(state.n));
    // },
    //点击的学生
    getActiveStudent(state, n) {
      state.activeStudent = n
      sessionStorage.setItem('zhimingActiveStudent', JSON.stringify(state.activeStudent))
    },
    //点击的小组
    getActiveGroup(state, n) {
      state.activeGroup = n;
    },
    //点击的小组数量
    getGroupNumber(state, n) {
      state.groupNumber = n;
    },
    //点击的学生数量
    getActiveNumber(state, n) {
      state.activeNumber = n;
    },
    //手动批改按键显示
    getManualCorrectionBtnShow(state, n) {
      state.manualCorrectionBtnShow = n;
      localStorage.setItem('zhimingManualCorrectionBtnShow', JSON.stringify(n))
    },
    //班级排名前后占比
    getReportRank(state, n) {
      state.reportRank = n;
      localStorage.setItem('zhimingReportRank', JSON.stringify(n))
    },
    //批改了的学生数据
    getCorrectStudentList(state, n) {
      state.correctStudentList = n;
      sessionStorage.setItem('CorrectStudentList', JSON.stringify(state.correctStudentList));
    },
    getquestionCorrect(state, n) {
      state.question_correct = n
      sessionStorage.setItem('CorrectQuestionList', JSON.stringify(state.CorrectQuestionList));
    },
    //是否一键全屏
    getIsFullScreen(state, n) {
      state.isFullScreen = n;
      sessionStorage.setItem('IsFullScreen', JSON.stringify(n));
    },
  },
  actions: {
    // 学生端不需要续课功能，已注释 checkServerTime
    // async checkServerTime({ commit }) {
    //   try {
    //     const response = await get_server_time();
    //     let plan_bgin_time = JSON.parse(localStorage.getItem('query_plan_time_by_room_id_class_id_plan_id_result'))
    //     const timeDifference = Math.abs(plan_bgin_time[plan_bgin_time.length-1].end_time - response.data.result.timestamp) / 60000;
    //     if (timeDifference < 10) {
    //       commit('setDialogVisibleTime', true);
    //     }
    //   } catch (error) {
    //   }
    // },
    // 定义一个action来重置所有状态  
    resetStore({ commit, state }) {
      // 遍历state的所有属性（这里假设我们不直接修改如_modules等内部属性）  
      for (let key in state) {
        if (state.hasOwnProperty(key)) {
          // 这里可以将所有状态重置为null  
          // 或者对于某些属性，重置为其他默认值   -- get加 大写的state第一个字符 +剩余字符
          if (key == 'activeStudent' || key == 'activeGroup') {
            //activeStudent 要变为空数组
            commit(`get${key.charAt(0).toUpperCase()}${key.slice(1)}`, []);
          } else {
            commit(`get${key.charAt(0).toUpperCase()}${key.slice(1)}`, null);
          }
          // 清除对应的localStorage项  
          localStorage.removeItem(`zhiming${key.charAt(0).toUpperCase()}${key.slice(1)}`);
        }
      }
    },
  },
  modules: {},
});
